const OPTIONS_SEARCH_BY = [
  {
    value: 'rmaId',
    label: 'RMA ID',
    title: 'by RMA ID',
  },
  {
    value: 'deviceId',
    label: 'Device ID',
    title: 'by Device ID',
  },
];

export { OPTIONS_SEARCH_BY };
